import { Email, Facebook, Link, Messenger, Twitter, Whatsapp } from '@menuzen/icon/build/outline';
import React from 'react';
import copy from 'copy-to-clipboard';
import Dialog, { DialogProps } from '../../components/dialog/Dialog';
import { enqueueSnackbar } from 'notistack';
import config from '../../config/config';

interface ShareModalProps extends DialogProps {
    url: string;
}

const ShareModal: React.FC<ShareModalProps> = ({ url, ...props }) => {
    const handleClickCopy = () => {
        copy(url);
        enqueueSnackbar('Link Copied!', { variant: 'success' });
    };
    return (
        <Dialog {...props}>
            <div className="px-30 pt-20 pb-50 flex space-x-15 overflow-auto">
                <div className="flex flex-col items-center" onClick={handleClickCopy}>
                    <div className="text-25 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                        <Link />
                    </div>
                    <p className="text-14 leading-17 whitespace-nowrap">Copy Link</p>
                </div>

                <a target="_blank" rel="noopener noreferrer" href={`mailto:?to=&body=${url}`}>
                    <div className="flex flex-col items-center">
                        <div className="text-30 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                            <Email />
                        </div>
                        <p className="text-14 leading-17">Email</p>
                    </div>
                </a>

                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://www.facebook.com/dialog/send?app_id=${config.fbAppId}&link=${url}&redirect_uri=${url}`}
                >
                    <div className="flex flex-col items-center">
                        <div className="text-30 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                            <Messenger />
                        </div>
                        <p className="text-14 leading-17 whitespace-nowrap">Messenger</p>
                    </div>
                </a>

                <a target="_blank" rel="noopener noreferrer" href={`https://api.whatsapp.com/send?text=${url}`}>
                    <div className="flex flex-col items-center">
                        <div className="text-30 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                            <Whatsapp />
                        </div>
                        <p className="text-14 leading-17">Whatsapp</p>
                    </div>
                </a>

                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                >
                    <div className="flex flex-col items-center">
                        <div className="text-30 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                            <Facebook />
                        </div>
                        <p className="text-14 leading-17">Facebook</p>
                    </div>
                </a>

                <a target="_blank" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?url=${url}`}>
                    <div className="flex flex-col items-center">
                        <div className="text-30 mb-10 h-65 w-65 rounded-full flex items-center justify-center bg-primary-10">
                            <Twitter />
                        </div>
                        <p className="text-14 leading-17">Twitter</p>
                    </div>
                </a>
            </div>
        </Dialog>
    );
};

export default ShareModal;
